module.exports = __webpack_public_path__ + "img/logo.a6bc6cfb.png";